module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left-nav"
  }, [_c('ul', {
    staticClass: "menu"
  }, _vm._l((_vm.components), function(data) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": data.path,
        "exact": ""
      }
    }, [_vm._v(_vm._s(data.name))]), _vm._v(" "), (data.child !== '') ? _c('div', {
      staticClass: "child"
    }, _vm._l((data.child), function(child) {
      return _c('ul', [_c('div', {
        staticClass: "title"
      }, [_vm._v("\n                        " + _vm._s(child.title) + "\n                    ")]), _vm._v(" "), _vm._l((child.components), function(component) {
        return _c('li', [_c('router-link', {
          attrs: {
            "to": component.path
          }
        }, [_vm._v("\n                            " + _vm._s(component.name) + "\n                            "), _c('span', {
          staticClass: "cn"
        }, [_vm._v(_vm._s(component.cn))])])], 1)
      })], 2)
    })) : _vm._e()], 1)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.9.9.5@vue-loader/lib/template-compiler.js?id=data-v-6a292ba2!./~/.9.9.5@vue-loader/lib/selector.js?type=template&index=0!./doc/components/leftNav.vue
// module id = 480
// module chunks = 27